import { Logout as LogoutIcon } from "@/components/icons/outline"
import { useAuth } from "@/contexts/auth-context"
import { useNavigate } from "react-router-dom"

export default function Logout() {
    // Contexts
    const { logout } = useAuth()

    // Hooks
    const navigate = useNavigate()

    const handleLogout = () => {
        logout()
        navigate(0)
    }

    return (
        <div className="fixed top-0 right-0 flex-col items-center justify-end hidden h-full min-h-screen px-2 py-4 pointer-events-none md:flex">
            <button onClick={handleLogout} className="px-4 py-2 text-red-500 bg-red-100 pointer-events-auto rounded-xl">
                <LogoutIcon className="w-7 h-7" strokeWidth={2} />
            </button>
        </div>
    )
}